import { daoPut } from 'mrf/Dao';
import { TYPE_GET_LIST, TYPE_GET_RAW, useFetcherSelector, useFormFullSelector, useFormSelector } from 'mrf/redux/ReduxHelper';
import { FormContext } from 'mrf/view/FormCRUD';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmationModal from 'mrf/view/ConfirmationModal';
import PropTypes from 'prop-types';
import QueryObjectField from 'mrf/view/QueryObjectField';

export default function UserInstitution({ userId }) {
    const { t } = useTranslation();
    const context = useFormSelector({ resource: 'userInstitutionForm' });
    const { data, set } = useFormFullSelector(context);
    
    const institution = useFetcherSelector({
        selector: state => state?.resources?.institutions?.byId?.[data?.institutionId],
        type: TYPE_GET_LIST,
        resource: 'institutions',
        endpoint: `/api/institutions`,
        condition: () => true,
    });

    const userInstitution = useFetcherSelector({
        selector: state => state?.resources?.userInstitutions,
        type: TYPE_GET_RAW,
        resource: 'userInstitutions',
        endpoint: `/api/users/${userId}/userInstitution`,
        condition: () => true,
    });

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [pendingInstitutionId, setPendingInstitutionId] = useState(null);

    useEffect(() => {
        set({ institutionId: userInstitution?.institutionId });
    }, [userInstitution, userInstitution?.institutionId]); // eslint-disable-line

    useEffect(() => {
        if (!data?.institutionId || data?.institutionId === userInstitution?.institutionId) {
            return;
        }
        setPendingInstitutionId(data.institutionId);
        setIsModalOpen(true);
    }, [data?.institutionId]); // eslint-disable-line

    const handleConfirm = () => {
        setIsModalOpen(false);

        daoPut(`/api/users/${userId}/institution`, { institutionId: pendingInstitutionId });
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        set({ institutionId: userInstitution?.institutionId });
    };

    const institutionFields = [
        { name: 'Name', key: 'name' },
        { name: 'Code', key: 'code' },
    ];

    return (
        <FormContext.Provider value={context}>
            <QueryObjectField
                label={t('Institution')}
                resource='institutions'
                endpoint={'/api/institutions'}
                displayAttribute='name'
                field='institutionId'
                fields={institutionFields}
                disableRemove
                disableAdd
                required
            />
            <ConfirmationModal
                isOpen={isModalOpen}
                onCancel={handleCancel}
                onConfirm={handleConfirm}
                title={t('Confirm Save')}
                message={t("Do you really want to change institution to {{institution}}?", {institution: institution?.name || ''})}
            />
        </FormContext.Provider>
    );
}

UserInstitution.propTypes = {
    userId: PropTypes.string.isRequired,
};